import Grid from "@material-ui/core/Grid";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { FcConferenceCall } from "react-icons/fc";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import FriendsOnYuukkeCard from "../../../components/FriendsOnYuukkeCard";
import i18n from "../../../i18n";
import AuthService from "../../../session/AuthService";

class FriendsOnYuukke extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FriendsList: [],
      recommendedFriendsList: [],
      recommendedFriendsListState: false,

    };
    this.getRecommendedFriendsList = this.getRecommendedFriendsList.bind(this);
    this.requestSentPage = this.requestSentPage.bind(this);
    this.gotoSuggestedFriendsList = this.gotoSuggestedFriendsList.bind(this);
    this.ignoreSentPage = this.ignoreSentPage.bind(this);
  }

  componentDidMount() {
    this.setState({
      FriendsList: this.props.FriendsList,
    });
    this.getRecommendedFriendsList(
      this.props.recommended_friends_list,
      this.props.recommendedListLength
    );
    let langValue = AuthService.getCommonLanguages();
    i18n.changeLanguage(langValue);
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("FriendsList", this.props.recommended_friends_list);
    if (
      prevProps.recommended_friends_list !== this.props.recommended_friends_list
    ) {
      this.getRecommendedFriendsList(
        this.props.recommended_friends_list,
        this.props.recommendedListLength
      );
    }
  }

  render() {
    const { t } = this.props;

    return (
      <div
        className="peopleCarouselWrapper"
        style={{ background: "#f5f5f5 0 0 no-repeat padding-box" }}
      >
 

        <Grid container spacing={2}>
          {this.props.recommended_friends_list &&
            this.props.recommended_friends_list.map((people, index) => {
              return (
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <React.Fragment key={index}>
                    <FriendsOnYuukkeCard
                      userId={people.uId}
                      name={people.userName}
                      Dname={people.dName}
                      searchvalue={this.props.searchvalue}
                      coverPhoto={people.coverPhoto}
                      userPhoto={people.profilePhoto}

                      nameLocation={
                        people.location !== null ? people.location : "--------"
                      }
                      country={
                        people.countryName !== null
                          ? people.countryName
                          : "--------"
                      }
                      profession={
                        people.professionName !== null
                          ? people.professionName
                          : "--------"
                      }
                      tagsValue={
                        people.tagsValue.length !== 0
                          ? people.tagsValue
                          : "---------"
                      }

                      requestSent={this.requestSentPage}
                      ignoreSent={this.ignoreSentPage}
                      premiumData={people?.premiumData}
                    />
                  </React.Fragment>
                </Grid>
              );
            })}
        </Grid>

        {this.props.recommended_friends_list.length === 0 && (
          <div
            className="communityCardWrapper cardWrapper"
            style={{ padding: "70px", marginTop: "20px" }}
          >
            <center>
              <div style={{ justifyContent: "center" }}>
                <FcConferenceCall
                  style={{
                    width: "55px",
                    height: "55px",
                    color: "#000000",
                  }}
                />

                {this.props.statefriendsPage !== 0 &&
                  this.props.propsfriendsPage === 0 && (
                    <p style={{ margin: "8px", fontSize: "20px" }}>
                      {t("No match found")}
                    </p>
                  )}
                {this.props.propsfriendsPage === this.props.statefriendsPage && (
                  <p style={{ margin: "8px", fontSize: "18px" }}>
                    {t("Yet to make connection")}
                  </p>
                )}
              </div>
            </center>
          </div>
        )}
      </div>
    );
  }

  ignoreSentPage() {
    this.props.ignoreSentPageData();
  }

  requestSentPage() {
    this.props.requestSentPageData();
  }

  async getRecommendedFriendsList(
    recommended_friends_list,
    recommendedListLength
  ) {
    console.log(recommended_friends_list);
    if (recommended_friends_list.length > 0) {
      await this.setState({
        recommendedFriendsList: recommended_friends_list,
        recommendedFriendsListState: false,
        recommendedListLengths: recommendedListLength,
      });
    } else {
      await this.setState({
        recommendedFriendsListState: true,
        recommendedListLengths: recommendedListLength,
      });
    }
  }

  gotoSuggestedFriendsList() {
    this.props.history.push({
      pathname: "/suggested-friends-list",
    });
  }
}

const mapStateToProps = function (state) {
  return {
    FriendsList: state.commonApi.friendslist,
  };
};
export default connect(mapStateToProps)(
  withTranslation()(withRouter(FriendsOnYuukke))
);
